import styled from 'styled-components'

const darkColor = props => props.theme.global.colors['dark-2']
const bgColor = props => props.theme.global.colors['background-back']

export const ReturnStatusBox = styled.div`
  border-radius: 4px;
  padding: 16px;
  background-color: ${bgColor};
`

export const MainReasonText = styled.h1`
  font-size: 16px;
  font-weight: 600;
  color: ${darkColor};
  margin: 0;
  line-height: 165%;
`

export const SubReasonText = styled.h1`
  font-size: 14px;
  font-weight: 400;
  color: ${darkColor};
  margin: 0;
  line-height: 165%;
`